module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external "antd"
// module id = 87
// module chunks = 3